import React from "react";
import PropTypes from "prop-types";
import { FormFor, Submit, TextArea, Select } from "react-rails-form-helpers";
import FormWrapper from "./styles/candidate-actions-ie-form";

const CandidateActionsIEForm = (props) => {
  const { offerMade, updateStatusLink } = props;

  return (
    <FormWrapper>
      <FormFor
        id="candidate-page-form"
        url={updateStatusLink}
        method="post"
        name="application_action"
        encType="multipart/form-data"
      >
        <Select
          name="action"
          id="candidate-page-select"
          form="candidate-page-form"
          defaultValue="send_message"
        >
          <option value="send_message">Send Message</option>
          <option value="telephone_interview_requested">
            Request Phone Interview
          </option>
          <option value="first_interview_requested">
            Request First Interview
          </option>
          <option value="second_interview_requested">
            Request Second Interview
          </option>
          <option value="competencies_required">Competencies Required</option>
          {offerMade ? (
            <option value="offer_cancelled">Cancel Offer</option>
          ) : (
            <option value="offered_job">Make Offer</option>
          )}
          <option value="rejected_candidate">Reject Candidate</option>
        </Select>
        <TextArea
          placeholder="Enter message here..."
          id="candidate-page-form-textarea"
          name="message"
        />
        <input
          type="file"
          id="candidate-page-file-input"
          name="application_action[attachment]"
        />
        <Submit id="candidate-page-submit-button" name="submit" value="Send" />
      </FormFor>
    </FormWrapper>
  );
};

CandidateActionsIEForm.propTypes = {
  offerMade: PropTypes.bool.isRequired,
  updateStatusLink: PropTypes.string.isRequired,
};

export default CandidateActionsIEForm;
